import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { PermissionsService } from '../services/ui/permissions.service';
import { PermissionCode } from '../constants/permission-codes.constants';

export const permissionGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => {
  const permissions = inject(PermissionsService);
  const router = inject(Router);

  const single = route.data['permission'] as PermissionCode | undefined;
  const anyOf = route.data['permissions'] as PermissionCode[] | undefined;
  const codes = anyOf ?? (single ? [single] : []);

  if (codes.length === 0) {
    console.error(
      'permissionGuard: ruta sin data.permission ni data.permissions',
      route,
    );
    return router.createUrlTree(['/403']);
  }

  return codes.some((code) => permissions.can(code))
    ? true
    : router.createUrlTree(['/403']);
};
